import React from 'react';
import './MobileMenu.css';

const MobileMenu = ({ onToggleSidebar }) => {
  return (
    <button
      className="hamburger-btn show-on-mobile"
      onClick={onToggleSidebar}
      aria-label="Open sidebar"
    >
      <span className="hamburger-icon" />
    </button>
  );
};

export default MobileMenu; 